import { render, staticRenderFns } from "./StockDetailSplit.vue?vue&type=template&id=0b3e30c9&scoped=true&"
import script from "./StockDetailSplit.vue?vue&type=script&lang=js&"
export * from "./StockDetailSplit.vue?vue&type=script&lang=js&"
import style0 from "./StockDetailSplit.vue?vue&type=style&index=0&id=0b3e30c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3e30c9",
  null
  
)

export default component.exports